import t from "../../app/i18n";

export enum InstitutionType {
  INSURANCE_COMPANY = "INSURANCE_COMPANY",
  SECURITIES_BROKER = "SECURITIES_BROKER",
  MANAGERIAL_PENSION_COMPANY = "MANAGERIAL_PENSION_COMPANY",
  SUPPLEMENTARY_PENSION_COMPANY = "SUPPLEMENTARY_PENSION_COMPANY",
  BANK = "BANK",
  BUILDING_SAVINGS_BANK = "BUILDING_SAVINGS_BANK",
  OTHER = "OTHER",
}

export enum InstitutionEnum {
  AGRA = "AGRA",
  ALLIANZ = "ALLIANZ",
  AXA_ASSISTANCE = "AXA_ASSISTANCE",
  AXA_NON_LIFE = "AXA_NON_LIFE",
  AXA_LIFE = "AXA_LIFE",
  COFACE = "COFACE",
  COLONNADE = "COLONNADE",
  CSOB = "CSOB",
  ECP = "ECP",
  EULER = "EULER",
  DEFEND = "DEFEND",
  GENERALI = "GENERALI",
  GENERTEL = "GENERTEL",
  GROUPAMA = "GROUPAMA",
  HDI = "HDI",
  KOMUNALNA = "KOMUNALNA",
  KOOPERATIVA = "KOOPERATIVA",
  MET_LIFE = "MET_LIFE",
  MET_LIFE_INSURANCE = "MET_LIFE_INSURANCE",
  MSIG = "MSIG",
  NN = "NN",
  NOVIS = "NOVIS",
  PILLOW = "PILLOW",
  PREMIUM = "PREMIUM",
  UNION = "UNION",
  UNIQA = "UNIQA",
  WUSTENROT = "WUSTENROT",
  YOUPLUS = "YOUPLUS",

  BANK_365 = "BANK_365",
  COFIDIS = "COFIDIS",
  CSOB_BANK = "CSOB_BANK",
  CSOB_LEASING = "CSOB_LEASING",
  MBANK = "MBANK",
  OBERBANK = "OBERBANK",
  OTP = "OTP",
  PRIMA = "PRIMA",
  PRIVATBANKA = "PRIVATBANKA",
  PSS = "PSS",
  SLSP = "SLSP",
  TATRA = "TATRA",
  TATRA_LEASING = "TATRA_LEASING",
  UNI_CREDIT = "UNI_CREDIT",
  UNI_CREDIT_LEASING = "UNI_CREDIT_LEASING",
  VUB = "VUB",

  AMUNDI = "AMUNDI",
  CAPITAL_MARKETS = "CAPITAL_MARKETS",
  CONSEQ = "CONSEQ",
  EIC = "EIC",
  FINAX = "FINAX",
  IAD = "IAD",
  PRIVATBANKA_OCP = "PRIVATBANKA_OCP",
  UNIQA_INVEST = "UNIQA_INVEST",
  WEM = "WEM",

  ALLIANZ_DSS = "ALLIANZ_DSS",
  KOOPERATIVA_DSS = "KOOPERATIVA_DSS",
  NN_DSS = "NN_DSS",
  UNIQA_DSS = "UNIQA_DSS",
  VUB_GENERALI_DSS = "VUB_GENERALI_DSS",

  NN_DDS = "NN_DDS",
  STABILITA_DDS = "STABILITA_DDS",
  UNIQA_DDS = "UNIQA_DDS",

  IBIS = "IBIS",
}

export const institutionTypeTMap = new Map<InstitutionType, string>(
  Object.values(InstitutionType).map((type) => [type, t("institution.enums.institutionType." + type)]),
);
